import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPostFile } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const uploadEntities = createAsyncThunk(
  "uploadEntities",
  async (arg, { rejectWithValue }) => {
    
    try {
      const response = await doPostFile(urls?.uploadEntities, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const uploadEntitiesSlice = createSlice({
  name: "uploadEntities",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    uploadEntitiesReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [uploadEntities.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.error = null;
      state.data = payload;
    },
    [uploadEntities.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    [uploadEntities.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.data = false;
    },
  },
});

export const { uploadEntitiesReset } = uploadEntitiesSlice.actions;
